import { styled } from 'styled-components';
import { IGlobaVariables } from '../../../components/Layout/styles';
import { IHeader3, defaultParams } from './params';

const Styles = styled.header<{
  theme?: IGlobaVariables;
  $config: IHeader3;
}>`
  .header {
    position: relative;
    background: ${({ $config: styles }) => styles.backgroundColor};
    overflow: hidden;

    &-wrapper {
      position: relative;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-content: center;
      align-items: stretch;
    }

    &-logo {
      margin: 0;
      text-decoration: none;
      min-height: ${({ $config: styles }) => styles.minHeight};
      display: flex;
      align-items: center;
      color: ${({ $config: styles }) => styles.group_logo.color};
      font-family: ${({ $config: styles }) => styles.group_logo.fontFamily};
      font-weight: ${({ $config: styles }) => styles.group_logo.fontWeight};
      font-size: ${({ $config: styles }) => styles.group_logo.fontSize};
      line-height: ${({ $config: styles }) => styles.group_logo.lineHeight};
      font-style: ${({ $config: styles }) => styles.group_logo.fontStyle};

      &:hover {
        color: ${({ $config: styles }) => styles.group_logo.color};
        text-decoration: none;
      }
    }

    &-navlinks {
      display: flex;
      flex-direction: column;
      height: 0;
      padding: 0;
      gap: 15px;
      transition: all 0.3s ease-in-out;

      &-button {
        position: absolute;
        color: ${({ $config: styles }) => styles.group_navlink.color};
        top: calc(${({ $config: styles }) => styles.minHeight} / 2 - 15px);
        right: 0;
        width: 30px;
        height: 30px;

        &:hover {
          cursor: pointer;
        }

        svg {
          width: 100%;
          height: 100%;
        }
      }

      a {
        width: auto;
        display: inline-flex;
        justify-content: center;
        align-items: center;
        min-height: ${({ $config: styles }) => styles.group_navlink.height};
        height: ${({ $config: styles }) => styles.group_navlink.height};
        margin: 0 auto;
        padding: 0 20px;
        color: ${({ $config: styles }) => styles.group_navlink.color};
        font-family: ${({ $config: styles }) => styles.group_navlink.fontFamily};
        font-weight: ${({ $config: styles }) => styles.group_navlink.fontWeight};
        font-size: ${({ $config: styles }) => styles.group_navlink.fontSize};
        text-decoration: ${({ $config: styles }) => styles.group_navlink.textDecoration};
        font-style: ${({ $config: styles }) => styles.group_navlink.fontStyle};
        background: ${({ $config: styles }) => styles.group_navlink.backgroundColor};
        border-radius: ${({ $config: styles }) => styles.group_navlink.borderRadius};
        border: ${({ $config: styles }) => styles.group_navlink.border};
        transition: color 0.2s ease-in-out, background-color 0.3s ease-in-out;
        &:hover {
          color: ${({ $config: styles }) => styles.group_navlink.hover_color};
          text-decoration: ${({ $config: styles }) => styles.group_navlink.hover_textDecoration};
          background: ${({ $config: styles }) => styles.group_navlink.hover_backgroundColor};
          border: ${({ $config: styles }) => styles.group_navlink.hover_border};
        }
      }

      &.show {
        height: calc(40px + 2 * ${({ $config: styles }) => styles.group_navlink.height});
      }
    }
  }

  @media (min-width: ${({ theme }) => theme.breakpoint.md}) {
    .header {
      &-wrapper {
        flex-direction: row;
        align-items: center;
        justify-content: space-between;
        flex-wrap: wrap;
      }

      &-group_logo {
        font-size: ${({ $config: styles }) => styles.group_logo.fontSize};
        line-height: ${({ $config: styles }) => styles.group_logo.lineHeight};
      }

      &-navlinks {
        padding: 0;
        margin: 0;
        flex-direction: row;
        justify-content: center;
        align-items: center;
        gap: 12px;
        max-height: 100%;

        &,
        &.show {
          height: ${({ $config: styles }) => styles.minHeight};
        }

        &-button {
          display: none;
        }
      }
    }
  }
`;

export default Styles;
